module.exports = __webpack_public_path__ + "static/media/post-11.7641fed2.jpg";